import type React from "react";

import style from "./HeaderContainer.module.css";

export const HeaderContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={style.container}>{children}</div>;
};
